
import React, { useState, useEffect } from "react";
import FilterListIcon from "../../../assets/images/FilterImg.svg";
import { useTheme, useMediaQuery } from "@mui/material";
import {
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Checkbox,
  ListItemText,
  Button,
  Box,
  Grid,
  CircularProgress
} from "@mui/material";
import { useParams } from "react-router-dom";
import { useSalesContext } from '../../../Pages/SalesContext';
import { styled } from "@mui/material/styles";
import { API_BASE_URL } from "../../../config/config.js";

const StyledButton = styled(Button)({
  margin: "8px 4px 2px 4px",
  padding: "0 1px",
  height: "16px",
  lineHeight: "16px",
  width: "calc(50% - 6px)",
  textAlign: "center",
  fontSize: "12px",
  color: "rgba(0, 0, 0, 0.8)",
  border: "1px solid transparent",
  borderRadius: "1px",
  backgroundColor: "rgba(0, 0, 0, 0.18)",
  textTransform: "none",
  boxShadow: "none",
  "&:hover": {
    backgroundColor: "rgba(0, 0, 0, 0.3)",
    boxShadow: "none",
  },
});
const selectStyles = {
  maxWidth: 270,
  height: 22,
  minWidth:77,
  borderRadius: "1px",
  borderWidth: "1px",
  gap: "4px",
  fontSize: "11px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "16px",
  textTransform: "uppercase",
  padding: "0",
 
  "& .MuiSelect-select": {
    width: "100%",
    textTransform: "uppercase",
    textOverflow: "clip",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
  "& .MuiSelect-icon": {
    marginLeft: "20px",
    right: "5px",
  },
};

const getAllFilterOptions = (data, selectedUserRole) => {
  debugger;
  const divisions = new Set();
  const zones = new Set();
  const regions = new Set();
  const hqs = new Set();
  const userIds = new Set(); // For MR usernames
  const flmManagerNames = new Set(); // For FLM manager names from manager_role
  const months = new Set(); // For months
  const years = new Set(); // For years
  const motherbrands = new Set(); // For brands
  const childbrands = new Set(); // For brands

  // Collect filter options from data, excluding empty strings
  data.filter_Data.forEach((division) => {
    if (division.divisionname && division.divisionname !== "") {
      divisions.add(division.divisionname);
    }
    division.zones.forEach((zone) => {
      if (zone.zonename && zone.zonename !== "") {
        zones.add(zone.zonename);
      }
      zone.regions.forEach((region) => {
        if (region.regionname && region.regionname !== "") {
          regions.add(region.regionname);
        }
        region.hQs.forEach((hq) => {
          if (hq.hqname && hq.hqname !== "") {
            hqs.add(hq.hqname);
          }
          hq.employees.forEach((employee) => {
            employee.brandFamilies.forEach((brand) => {
              if (brand.brandfamilyname && brand.brandfamilyname !== "") {
                motherbrands.add(brand.brandfamilyname);
              }
              brand.brands.forEach((childbrand) => {
                if (childbrand.brandname && childbrand.brandname !== "") {
                  childbrands.add(childbrand.brandname);
                }
              });
            });
            if (employee.user_role.toUpperCase() === "MR" && employee.username && employee.username !== "") {
              userIds.add(employee.username); // Collect MR usernames
            }
            // Collect manager_name where manager_role is FLM
            if (
              employee.manager_role &&
              employee.manager_role.toUpperCase() === "FLM" &&
              employee.manager_name &&
              employee.manager_name !== ""
            ) {
              flmManagerNames.add(employee.manager_name);
            }
          });
        });
      });
    });
  });

  // Define hierarchy based on user role
  const hierarchyLevels = {
    SLM: ["SLM", "FLM", "MR"],
    FLM: ["FLM", "MR"],
    MR: ["MR"],
  };

  const userRole = data.user_Details.user_Role.toUpperCase();
  const availableRoles = hierarchyLevels[userRole] || ["MR"];

  // Determine user_id options based on selected user_role
  let userIdOptions;
  if (userRole === "SLM") {
    if (selectedUserRole === "SLM") {
      userIdOptions = data.user_Details.userName && data.user_Details.userName !== ""
        ? [data.user_Details.userName]
        : [];
    } else if (selectedUserRole === "FLM") {
      userIdOptions = flmManagerNames.size > 0 ? Array.from(flmManagerNames) : ["No FLM Managers Found"];
    } else if (selectedUserRole === "MR") {
      userIdOptions = userIds.size > 0 ? Array.from(userIds) : ["No MR Employees Found"];
    }
  } else if (userRole === "FLM" && selectedUserRole === "FLM") {
    userIdOptions = data.user_Details.userName && data.user_Details.userName !== ""
      ? [data.user_Details.userName]
      : [];
  } else {
    userIdOptions = userIds.size > 0 ? Array.from(userIds) : ["No Employees Found"];
  }

  let availableMonths = data.months;
  let availableYears = data.years;

  return {
    division: Array.from(divisions),
    zone: Array.from(zones),
    region: Array.from(regions),
    hq: Array.from(hqs),
    motherbrands: Array.from(motherbrands),
    childbrands: Array.from(childbrands),
    user_role: availableRoles,
    user_id: userIdOptions,
    salesIn: ["Lacs", "Crores"],
    months: availableMonths,
    years: availableYears,
  };
};


const getCodeMappings = (data) => {
  const divisionMap = {};
  const zoneMap = {};
  const regionMap = {};
  const hqMap = {};
  const userIdMap = {};
  const months = {};
  const years = {};
  const motherbrandMap = {};
  const childbrandMap = {};
  const flmToReportsMap = {};
  data.filter_Data.forEach((division) => {
    divisionMap[division.divisionname] = division.divisioncode;
    division.zones.forEach((zone) => {
      zoneMap[zone.zonename] = zone.zonecode;
      zone.regions.forEach((region) => {
        regionMap[region.regionname] = region.regioncode;
        region.hQs.forEach((hq) => {
          hqMap[hq.hqname] = hq.hqcode;
          hq.employees.forEach((employee) => {
            employee.brandFamilies.forEach((brand) => {
              motherbrandMap[brand.brandfamilyname] = brand.brandfamilycode;
              brand.brands.forEach((childbrand) => {
                childbrandMap[childbrand.brandname] = childbrand.brandcode;
              });
            });
            if (employee.user_role.toUpperCase() === "MR") {
              userIdMap[employee.username] = employee.userid;
            }
            if (
              employee.manager_role &&
              employee.manager_role.toUpperCase() === "FLM" &&
              employee.manager_name
            ) {
              userIdMap[employee.manager_name] = employee.reporting_manager_id;
            } if (
              employee.manager_role?.toUpperCase() === "FLM" &&
              employee.reporting_manager_id
            ) if (
              employee.manager_role?.toUpperCase() === "FLM" &&
              employee.reporting_manager_id
            ) {
              if (!flmToReportsMap[employee.reporting_manager_id]) {
                flmToReportsMap[employee.reporting_manager_id] = [];
              }
              if (employee.user_role.toUpperCase() === "MR") {
                flmToReportsMap[employee.reporting_manager_id].push(employee.userid);
              }
            }
          
          });
        });
      });
    });
  });

  userIdMap[data.user_Details.userName] = data.user_Details.user_Id;
  months[data.months] = data.months;
  years[data.years] = data.years;
  console.log("Months:", months, years, userIdMap ,data.user_Details.user_Id );
  return {
    divisionMap,
    zoneMap,
    regionMap,
    hqMap,
    userIdMap,
    months,
    years,
    motherbrandMap,
    childbrandMap,
    flmToReportsMap,
  };
};
const getAllOptionsForSLM = (data) => {
  const divisions = new Set();
  const zones = new Set();
  const regions = new Set();
  const hqs = new Set();
  const motherbrands = new Set();
  const childbrands = new Set();
const months = new Set();
const years = new Set();
  
  data.filter_Data.forEach((division) => {
    if (division.divisionname && division.divisionname !== "") {
      divisions.add(division.divisionname);
    }
    division.zones.forEach((zone) => {
      if (zone.zonename && zone.zonename !== "") {
        zones.add(zone.zonename);
      }
      zone.regions.forEach((region) => {
        if (region.regionname && region.regionname !== "") {
          regions.add(region.regionname);
        }
        region.hQs.forEach((hq) => {
          if (hq.hqname && hq.hqname !== "") {
            hqs.add(hq.hqname);
          }
          hq.employees.forEach((employee) => {
            employee.brandFamilies.forEach((brand) => {
              if (brand.brandfamilyname && brand.brandfamilyname !== "") {
                motherbrands.add(brand.brandfamilyname);
              }
              brand.brands.forEach((childbrand) => {
                if (childbrand.brandname && childbrand.brandname !== "") {
                  childbrands.add(childbrand.brandname);
                }
              });
            });
          }
        );
        });
      });
    });
  });
  months.add(data.months);
  years.add(data.years);
  console.log(data.months)
  return {
    division: Array.from(divisions),
    zone: Array.from(zones),
    region: Array.from(regions),
    hq: Array.from(hqs),
    motherbrands: Array.from(motherbrands),
    childbrands: Array.from(childbrands),
    months: data.months,
    years: data.years,
  };
}
const getRelatedSelections = (data, filter, values) => {
  const related = {
    division: new Set(),
    zone: new Set(),
    region: new Set(),
    hq: new Set(),
    user_id: new Set(),
    months: new Set(),
    years: new Set(),
    motherbrands: new Set(),
    childbrands: new Set(),
  };
  const userRole = data.user_Details.user_Role.toUpperCase();
  const slmUserName = data.user_Details.userName;
   // If SLM user_id is included in values and filter is user_id, return all options
   if (filter === "user_id" && userRole === "SLM" && values.includes(slmUserName)) {
    const allOptions = getAllOptionsForSLM(data);
    return {
      division: allOptions.division,
      zone: allOptions.zone,
      region: allOptions.region,
      hq: allOptions.hq,
      user_id: values, // Preserve the selected user_ids
      months: allOptions.months,
      years: allOptions.years,
      motherbrands: allOptions.motherbrands,
      childbrands: allOptions.childbrands,
    };
  }
  data.filter_Data.forEach((division) => {
    division.zones.forEach((zone) => {
      zone.regions.forEach((region) => {
        region.hQs.forEach((hq) => {
          hq.employees.forEach((employee) => {
            employee.brandFamilies.forEach((brand) => {
              brand.brands.forEach((childbrand) => {
                const matchesFilter =
                  (filter === "division" && values.includes(division.divisionname)) ||
                  (filter === "zone" && values.includes(zone.zonename)) ||
                  (filter === "region" && values.includes(region.regionname)) ||
                  (filter === "hq" && values.includes(hq.hqname)) ||
                  (filter === "months" && values.includes(data.months)) ||
                  (filter === "years" && values.includes(data.years)) ||
                  (filter === "motherbrands" && values.includes(brand.brandfamilyname)) ||
                  (filter === "childbrands" && values.includes(childbrand.brandname))||
                  (filter === "user_id" &&
                  ((employee.user_role.toUpperCase() === "MR" && values.includes(employee.username)) ||
                   (employee.manager_role?.toUpperCase() === "FLM" && values.includes(employee.manager_name)))) 

                if (matchesFilter) {
                  related.division.add(division.divisionname);
                  related.zone.add(zone.zonename);
                  related.region.add(region.regionname);
                  related.hq.add(hq.hqname);
                  related.motherbrands.add(brand.brandfamilyname);
                  related.childbrands.add(childbrand.brandname);
                  related.months.add(data.months);
                  related.years.add(data.years);

                  if (employee.user_role.toUpperCase() === "MR") {
                    related.user_id.add(employee.username);
                  }
                  if (employee.manager_role?.toUpperCase() === "FLM" && employee.manager_name) {
                    related.user_id.add(employee.manager_name);
                  }
                }
              });
            });
          });
        });
      });
    });
  });

  return {
    division: Array.from(related.division),
    zone: Array.from(related.zone),
    region: Array.from(related.region),
    hq: Array.from(related.hq),
    user_id: Array.from(related.user_id),
    months: Array.from(related.months),
    years: Array.from(related.years),
    motherbrands: Array.from(related.motherbrands),
    childbrands: Array.from(related.childbrands),
  };
};

const StockistFilter = React.memo((user_id) => {
  const { updateSalesUnit, setKpiData , setLoading} = useSalesContext();
  const { userId } = useParams();
  const [filterData, setFilterData] = useState(null);
  const [selectedFilters, setSelectedFilters] = useState(null);
  const [tempFilters, setTempFilters] = useState(null);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [initialUserRole, setInitialUserRole] = useState(null); 
  const theme = useTheme();
  
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));  // mobile
  const isSm = useMediaQuery(theme.breakpoints.between("sm", "md")); // tablet
  const isMdUp = useMediaQuery(theme.breakpoints.up("md")); // desktop
  
  const maxTextLength = isXs ? 4 : isSm ? 7 : 10;
  useEffect(() => {
     let userId = "demouser73@mankind.com";
     const userObject = user_id; // Your user object
     const userId2 = userObject.user_id; // Extract user_id from the object
     console.log(userId2);
     const finalUserId = userId2 ? userId2 : userId;
     setLoading(true);
     fetch(
       `${API_BASE_URL}Filters/Filters?userId=${finalUserId}&userType=SAP_USER`
     )
       .then((response) => response.json())
       .then((data) => {
         console.log("API Response:", data);
         setLoading(false);
         setFilterData(data);
         setInitialUserRole(data.user_Details.user_Role.toUpperCase());
         const filterOptions = getAllFilterOptions(
           data,
           data.user_Details.user_Role
         );
         console.log("Initial Filter Options:", filterOptions);
 
         const initialUserRole = data.user_Details.user_Role.toUpperCase();
         const initialFilterOptions = getAllFilterOptions(data, initialUserRole);
 const currentMonthName = new Date().toLocaleString('default', { month: 'long' });
const currentMonthFromOptions = filterOptions.months.find(
  (month) => month.toLowerCase() === currentMonthName.toLowerCase()
);
         const initialFilters = {
           division: filterOptions.division,
           zone: filterOptions.zone,
           region: filterOptions.region,
           hq: filterOptions.hq,
           user_role: initialUserRole, // Default to user's role
           user_id: initialFilterOptions.user_id,
           salesIn: filterOptions.salesIn[0],
          months: currentMonthFromOptions ? [currentMonthFromOptions] : [],
           years: [filterOptions.years[2]],
           motherbrands: filterOptions.motherbrands,
           childbrands: filterOptions.childbrands,
         };
         console.log("Initial Filter Options:", initialFilterOptions ,filterOptions.years[2]);
         console.log("Initial Filters:", initialFilters);
         setSelectedFilters(initialFilters);
         setTempFilters(initialFilters);
       })
       .catch((error) => {
         console.error("Error fetching filter data:", error);
       });
   }, [user_id]);
 
   const convertToCodeFormat = (selectedFilters, mappings ,userRole ,filterData) => {
     console.log("Selected Filters:", selectedFilters, mappings);
     const {
       divisionMap,
       zoneMap,
       regionMap,
       hqMap,
       userIdMap,
       months,
       years,
       motherbrandMap,
       childbrandMap,
       flmToReportsMap
     } = mappings;
     const userIds = getFilteredUserIds(filterData, selectedFilters, userRole, flmToReportsMap);
     return {
       divisioncode: selectedFilters?.division.map((name) => divisionMap[name]),
       zonecode: selectedFilters?.zone.map((name) => zoneMap[name]),
       regioncode: selectedFilters?.region.map((name) => regionMap[name]),
       hqcode: selectedFilters?.hq.map((name) => hqMap[name]),
       // user_role: selectedFilters?.user_role,
        user_role: userRole==="SLM" ? "SLM" :"MR",
   user_id: userIds,
       months: selectedFilters?.months,
       years: selectedFilters?.years,
       brandfamilycode: selectedFilters?.motherbrands.map(
         (name) => motherbrandMap[name]
       ),
       brandcode: selectedFilters?.childbrands.map((name) => childbrandMap[name]),
     };
     
     
   };
 
   useEffect(() => {
     if (selectedFilters && filterData && initialUserRole) {
       const mappings = getCodeMappings(filterData);
       const codeFormat = convertToCodeFormat(selectedFilters, mappings, initialUserRole ,filterData);
       updateSalesUnit(selectedFilters.salesIn);
       setLoading(true);
       fetch(`${API_BASE_URL}Dashboard/StockistDashboard`, {
         method: "POST",
         headers: {
           "Content-Type": "application/json",
         },
         body: JSON.stringify(codeFormat),
       })
         .then((response) => response.json())
         .then((data) => {
           setKpiData(data);
           setLoading(false);
           console.log("API Response:", data);
         })
         .catch((error) => {
           console.error("Initial API Error:", error);
         });
     }
   }, [selectedFilters, filterData , initialUserRole]);
 
   const singleSelectFilters = ["user_role", "salesIn"];
  const getFilteredUserIds = (filterData, selectedFilters, userRole, flmToReportsMap) => {
     const userIds = new Set();
   
     // Case 1: MR hierarchy with specific user_id(s) selected
     if (selectedFilters?.user_role === "MR" && selectedFilters?.user_id?.length > 0) {
       let found = false;
       filterData?.filter_Data?.forEach((division) => {
         division.zones.forEach((zone) => {
           zone.regions.forEach((region) => {
             region.hQs.forEach((hq) => {
               hq.employees.forEach((employee) => {
                 if (
                   employee.user_role.toUpperCase() === "MR" &&
                   employee.userid &&
                   selectedFilters.user_id.includes(employee.username)
                 ) {
                   userIds.add(employee.userid);
                   found = true;
                 }
               });
             });
           });
         });
       });
       if (!found) {
         console.warn("No MR employees found for the selected user IDs.");
       }
       return Array.from(userIds);
     }
   
     if (
       userRole === "SLM" &&
       selectedFilters?.user_role === "MR" &&
       selectedFilters?.user_id?.length > 0
     ) {
       let found = false;
       filterData?.filter_Data?.forEach((division) => {
         division.zones.forEach((zone) => {
           zone.regions.forEach((region) => {
             region.hQs.forEach((hq) => {
               hq.employees.forEach((employee) => {
                 if (
                   employee.user_role.toUpperCase() === "MR" &&
                   employee.userid &&
                   selectedFilters.user_id.includes(employee.username)
                 ) {
                   userIds.add(employee.userid);
                   found = true;
                 }
               });
             });
           });
         });
       });
       if (!found) {
         console.warn("No MR employees found for the selected user IDs.");
       }
       return Array.from(userIds);
     }
   
     if (userRole === "SLM" && filterData?.user_Details?.user_Id) {
       userIds.add(filterData.user_Details.user_Id);
     }
   
     filterData?.filter_Data?.forEach((division) => {
       division.zones.forEach((zone) => {
         zone.regions.forEach((region) => {
           if (
             selectedFilters?.region?.length > 0 &&
             !selectedFilters.region.includes(region.regionname)
           ) {
             return;
           }
   
           region.hQs.forEach((hq) => {
             hq.employees.forEach((employee) => {
               if (
                 employee.user_role.toUpperCase() === "MR" &&
                 employee.userid
               ) {
                 userIds.add(employee.userid);
               }
               if (
                 employee.manager_role?.toUpperCase() === "FLM" &&
                 employee.reporting_manager_id
               ) {
                 userIds.add(employee.reporting_manager_id);
               }
             });
           });
         });
       });
     });
   
     // For FLM users, include their own user ID and reporting employees
     if (userRole === "FLM" && selectedFilters?.user_id?.length > 0) {
       const flmUserId = filterData.user_Details.user_Id;
       if (selectedFilters.user_id.includes(filterData.user_Details.userName)) {
         userIds.add(flmUserId);
       }
   
       const reportingUserIds = selectedFilters.user_id
         .filter((username) => flmToReportsMap[filterData.user_Details.user_Id])
         .flatMap(() => flmToReportsMap[filterData.user_Details.user_Id] || []);
   
       reportingUserIds.forEach((id) => userIds.add(id));
     }
   
     return Array.from(userIds);
   };

  const handleChange = (filter, event) => {
     const value = event.target.value;
     debugger;
     const filterOptions = getAllFilterOptions(filterData, selectedFilters.user_role);
     const multiSelectFilters = ["division", "zone", "region", "hq", "user_id","motherbrands", "childbrands", "months" , "years"];
     if (singleSelectFilters.includes(filter)) {
       if (filter === "user_role") {
         const newFilterOptions = getAllFilterOptions(filterData, value);
         const resetFilters = {
           division: newFilterOptions.division,
           zone: newFilterOptions.zone,
           region: newFilterOptions.region,
           hq: newFilterOptions.hq,
           user_role: value,
           user_id: newFilterOptions.user_id.filter((id) => !id.includes("No ")),
           salesIn: selectedFilters.salesIn, 
           months: newFilterOptions.months,
           years: newFilterOptions.years,
           motherbrands : newFilterOptions.motherbrands,
           childbrands : newFilterOptions.childbrands,
         };
   
         setSelectedFilters(resetFilters);
         setTempFilters(resetFilters);

         const mappings = getCodeMappings(filterData);
         const codeFormat = convertToCodeFormat(resetFilters, mappings, value,filterData);
         console.log("Hierarchy Change with Reset Code Format:", codeFormat);
   
         fetch(`${API_BASE_URL}/Dashboard/BreakageExpiryDashboard`, {
           method: "POST",
           headers: {
             "Content-Type": "application/json",
           },
           body: JSON.stringify(codeFormat),
         })
           .then((response) => response.json())
           .then((data) => {
             setLoading(false);
             setKpiData(data);
           })
           .catch((error) => {
             console.error("Hierarchy Change API Error:", error);
           });
       } else {
         // Handle other single-select filters (e.g., salesIn)
         setSelectedFilters((prev) => {
           const updated = { ...prev, [filter]: value };
           if (filter === "salesIn") {
             updateSalesUnit(value);
           }
           return updated;
         });
         setTempFilters((prev) => ({
           ...prev,
           [filter]: value,
         }));
       }
       setOpenDropdown(null);
     } else {
       const filterOptions = getAllFilterOptions(filterData, selectedFilters.user_role);
       if (value.includes("all")) {
        const isSelectingAll = tempFilters[filter].length !== filterOptions[filter].length;
        setTempFilters((prev) => ({
          ...prev,
          [filter]: isSelectingAll ? [...filterOptions[filter]] : [],
        }));
       } else {
         setTempFilters((prev) => {
           const updated = {
             ...prev,
             [filter]: value,
           };
           if (filter === "user_id") {
             const relatedSelections = getRelatedSelections(filterData, filter, value);
             return {
               ...updated,
               division: relatedSelections.division,
               zone: relatedSelections.zone,
               region: relatedSelections.region,
               hq: relatedSelections.hq,
               months: relatedSelections.months,
               years: relatedSelections.years,
               motherbrands: relatedSelections.motherbrands,
               childbrands: relatedSelections.childbrands,
             };
           }else {
            const relatedSelections = getRelatedSelections(filterData, filter, value);
            return {
              ...updated,
              division: filter === "division" ? value : relatedSelections.division.length > 0 ? relatedSelections.division : prev.division,
             zone: filter === "zone" ? value : relatedSelections.zone.length > 0 ? relatedSelections.zone : prev.zone,
             region: filter === "region" ? value : relatedSelections.region.length > 0 ? relatedSelections.region : prev.region,
             hq: filter === "hq" ? value : relatedSelections.hq.length > 0 ? relatedSelections.hq : prev.hq,
             user_id: relatedSelections.user_id.length > 0 ? relatedSelections.user_id : prev.user_id,
            };
           }
           return updated;
         });
       }
     }
   };
   
   const handleApply = (filter) => {
     const newSelected = tempFilters[filter];
     const mappings = getCodeMappings(filterData);
     const filterOptions = getAllFilterOptions(filterData, selectedFilters.user_role);
     const multiSelectFilters = ["division", "zone", "region", "hq", "user_id"];
   
     setSelectedFilters((prev) => {
       let updatedFilters = { ...prev, [filter]: newSelected };
     if (
         multiSelectFilters.includes(filter) &&
         newSelected.length === filterOptions[filter].length
       ) {
         multiSelectFilters.forEach((multiFilter) => {
           updatedFilters[multiFilter] = [...filterOptions[multiFilter]];
         });
       } else {
         const relatedSelections = getRelatedSelections(filterData, filter, newSelected);
         if (filter === "user_id") {
           updatedFilters.division = relatedSelections.division.length > 0 ? relatedSelections.division : filterOptions.division;
           updatedFilters.zone = relatedSelections.zone.length > 0 ? relatedSelections.zone : filterOptions.zone;
           updatedFilters.region = relatedSelections.region.length > 0 ? relatedSelections.region : filterOptions.region;
           updatedFilters.hq = relatedSelections.hq.length > 0 ? relatedSelections.hq : filterOptions.hq;
         } else if (filter === "division") {
           updatedFilters.zone = relatedSelections.zone.length > 0 ? relatedSelections.zone : filterOptions.zone;
           updatedFilters.region = relatedSelections.region.length > 0 ? relatedSelections.region : filterOptions.region;
           updatedFilters.hq = relatedSelections.hq.length > 0 ? relatedSelections.hq : filterOptions.hq;
           updatedFilters.user_id = relatedSelections.user_id.length > 0 ? relatedSelections.user_id : filterOptions.user_id;
         } else if (filter === "zone") {
           updatedFilters.division = relatedSelections.division.length > 0 ? relatedSelections.division : filterOptions.division;
           updatedFilters.region = relatedSelections.region.length > 0 ? relatedSelections.region : filterOptions.region;
           updatedFilters.hq = relatedSelections.hq.length > 0 ? relatedSelections.hq : filterOptions.hq;
           updatedFilters.user_id = relatedSelections.user_id.length > 0 ? relatedSelections.user_id : filterOptions.user_id;
         } else if (filter === "region") {
           updatedFilters.division = relatedSelections.division.length > 0 ? relatedSelections.division : filterOptions.division;
           updatedFilters.zone = relatedSelections.zone.length > 0 ? relatedSelections.zone : filterOptions.zone;
           updatedFilters.hq = relatedSelections.hq.length > 0 ? relatedSelections.hq : filterOptions.hq;
           updatedFilters.user_id = relatedSelections.user_id.length > 0 ? relatedSelections.user_id : filterOptions.user_id;
         } else if (filter === "hq") {
           updatedFilters.division = relatedSelections.division.length > 0 ? relatedSelections.division : filterOptions.division;
           updatedFilters.zone = relatedSelections.zone.length > 0 ? relatedSelections.zone : filterOptions.zone;
           updatedFilters.region = relatedSelections.region.length > 0 ? relatedSelections.region : filterOptions.region;
           updatedFilters.user_id = relatedSelections.user_id.length > 0 ? relatedSelections.user_id : filterOptions.user_id;
         }
       }
   
       const prevSelected = prev[filter];
       const hasChanged = JSON.stringify(newSelected) !== JSON.stringify(prevSelected);
   
       if (hasChanged) {
         const codeFormat = convertToCodeFormat(updatedFilters, mappings, selectedFilters.user_role, filterData);
         fetch(`${API_BASE_URL}/Dashboard/StockistDashboard`, {
           method: "POST",
           headers: {
             "Content-Type": "application/json",
           },
           body: JSON.stringify(codeFormat),
         })
           .then((response) => response.json())
           .then((data) => {
             setLoading(false);
             setKpiData(data);
           })
           .catch((error) => {
             console.error("API Error:", error);
           });
       }
   
       return updatedFilters;
     });
     setTempFilters((prev) => {
      debugger;
       const updatedTempFilters = { ...prev, [filter]: newSelected };
       if (
         multiSelectFilters.includes(filter) &&
         newSelected.length === filterOptions[filter].length
       ) {
         multiSelectFilters.forEach((multiFilter) => {
           updatedTempFilters[multiFilter] = [...filterOptions[multiFilter]];
         });
       } else {
         const relatedSelections = getRelatedSelections(filterData, filter, newSelected);
        if (filter === "division") {
           updatedTempFilters.zone = relatedSelections.zone.length > 0 ? relatedSelections.zone : filterOptions.zone;
           updatedTempFilters.region = relatedSelections.region.length > 0 ? relatedSelections.region : filterOptions.region;
           updatedTempFilters.hq = relatedSelections.hq.length > 0 ? relatedSelections.hq : filterOptions.hq;
           updatedTempFilters.user_id = relatedSelections.user_id.length > 0 ? relatedSelections.user_id : filterOptions.user_id;
         } else if (filter === "zone") {
           updatedTempFilters.division = relatedSelections.division.length > 0 ? relatedSelections.division : filterOptions.division;
           updatedTempFilters.region = relatedSelections.region.length > 0 ? relatedSelections.region : filterOptions.region;
           updatedTempFilters.hq = relatedSelections.hq.length > 0 ? relatedSelections.hq : filterOptions.hq;
           updatedTempFilters.user_id = relatedSelections.user_id.length > 0 ? relatedSelections.user_id : filterOptions.user_id;
         } else if (filter === "region") {
           updatedTempFilters.division = relatedSelections.division.length > 0 ? relatedSelections.division : filterOptions.division;
           updatedTempFilters.zone = relatedSelections.zone.length > 0 ? relatedSelections.zone : filterOptions.zone;
           updatedTempFilters.hq = relatedSelections.hq.length > 0 ? relatedSelections.hq : filterOptions.hq;
           updatedTempFilters.user_id = relatedSelections.user_id.length > 0 ? relatedSelections.user_id : filterOptions.user_id;
         } else if (filter === "hq") {
           updatedTempFilters.division = relatedSelections.division.length > 0 ? relatedSelections.division : filterOptions.division;
           updatedTempFilters.zone = relatedSelections.zone.length > 0 ? relatedSelections.zone : filterOptions.zone;
           updatedTempFilters.region = relatedSelections.region.length > 0 ? relatedSelections.region : filterOptions.region;
           updatedTempFilters.user_id = relatedSelections.user_id.length > 0 ? relatedSelections.user_id : filterOptions.user_id;
         }
       }
       return updatedTempFilters;
     });
   
     setOpenDropdown(null);
   };

  const handleCancel = (filter) => {
    setTempFilters((prev) => ({ ...prev, [filter]: selectedFilters[filter] }));
    setOpenDropdown(null);
  };

  const handleOpen = (filter) => {
    setTempFilters((prev) => ({ ...prev, [filter]: selectedFilters[filter] }));
    setOpenDropdown(filter);
  };



  if (!filterData || !selectedFilters || !tempFilters) {
    return  <Box sx={{ p: 2, display: "flex", justifyContent: "center", alignItems: "center" }}>
            <CircularProgress />
          </Box>;
  }

  const filterOptions = getAllFilterOptions(filterData, selectedFilters.user_role);
console.log("Filter Options:", filterOptions);
const excludedFilters = ["user_id", "user_role", "motherbrands", "childbrands"];
  return (
    <div className="new-filter-bar-sticky">
<div className="filter-container">

    <img src={FilterListIcon} alt="Filter Icon" className="filter-icon" />

<Grid container spacing={2} sx={{ flexWrap: "nowrap" }}>
  {Object.keys(filterOptions)
    .filter((filter) => !excludedFilters.includes(filter))
    .map((filter) => (
      <Grid item xs={1.7} key={filter}>
        <InputLabel
          sx={{
            textTransform: "capitalize",
            fontWeight: 400,
            fontSize: "14px",
            lineHeight: "12px",
            letterSpacing: "0%",
            padding: "3px 3px",
            color: "red",
          }}
        >
          {filter === "years"
            ? "Years"
            : filter === "months"
            ? "Months"
            : filter === "hq"
            ? "HQ"
            : filter === "salesIn"
            ? "Sales In"
            : filter}
        </InputLabel>
        <FormControl fullWidth>
          <Select
            multiple={!singleSelectFilters.includes(filter)}
                
                open={openDropdown === filter}
                onOpen={() => handleOpen(filter)}
                // onClose={() => setOpenDropdown(null)}
                onClose={() => {
    setTempFilters((prev) => ({ ...prev, [filter]: selectedFilters[filter] })); // Revert tempFilters to selectedFilters
    setOpenDropdown(null);
  }}
            value={
              singleSelectFilters.includes(filter)
                ? selectedFilters[filter]
                : tempFilters[filter]
            }
            onChange={(event) => handleChange(filter, event)}
            renderValue={(selected) => {
              const text = Array.isArray(selected)
                ? selected
                    .map((option) => {
                      if (typeof option === "string") {
                        return filter === "years"
                          ? `FY ${parseInt(option.split(" ")[1]) + 1}`
                          : option;
                      } else {
                        console.error("option is not a string:", option);
                        return option;
                      }
                    })
                    .join(", ")
                : typeof selected === "string" && filter === "years"
                ? `FY ${parseInt(selected.split(" ")[1]) + 1}`
                : selected;

              return text.length > maxTextLength
                ? `${text.substring(0, maxTextLength)}...`
                : text;
            }}
            
            sx={selectStyles}
            size="small"
          >
                    {!singleSelectFilters.includes(filter) && (
                  <MenuItem value="all">
                    <Checkbox
                       checked={
                        tempFilters[filter].length === filterOptions[filter].length
                      }
                      sx={{
                        transform: "scale(0.8)",
                        padding: "0 !important",
                        "& .MuiSvgIcon-root": { fontSize: "19px" },
                      }}
                    />
                    <ListItemText
                      primary="Select All"
                      primaryTypographyProps={{ fontSize: "12px !important" }}
                      sx={{
                        padding: "0 !important",
                        textTransform: "uppercase",
                      }}
                    />
                  </MenuItem>
                )}
                {filterOptions[filter].map((option) => {
  const yearMatch = option.match(/FY (\d{4})/);
  const nextYearLabel = yearMatch ? `FY ${parseInt(yearMatch[1]) + 1}` : option;
  return (
    <MenuItem key={option} value={option}>
      {!singleSelectFilters.includes(filter) && (
        <Checkbox
          checked={tempFilters[filter].includes(option)}
          sx={{
            transform: "scale(0.8)",
            padding: "0 !important",
            "& .MuiSvgIcon-root": { fontSize: "19px" },
          }}
        />
      )}
      <ListItemText
        primary={nextYearLabel}
        primaryTypographyProps={{ fontSize: "12px !important" }}
        sx={{
          padding: "0 !important",
          textTransform: "uppercase",
        }}
      />
    </MenuItem>
  );
})}
            {!singleSelectFilters.includes(filter) && (
              <Box display="flex" justifyContent="space-between" p={0}>
                <StyledButton
                  variant="contained"
                  color="primary"
                  onClick={() => handleApply(filter)}
                  disabled={tempFilters[filter].length === 0}
                >
                  Apply
                </StyledButton>
                <StyledButton
                  variant="outlined"
                  color="secondary"
                  onClick={() => handleCancel(filter)}
                >
                  Cancel
                </StyledButton>
              </Box>
            )}
          </Select>
        </FormControl>
      </Grid>
    ))}
</Grid>

  </div>
    </div>
    
  
  );
});

export default StockistFilter;